import { useMediaQuery, useTheme } from "@mui/material";
import axios from "axios";
import AuthContainer from "components/Auth/AuthContainer";
import Footer from "components/Footer";
import Header from "components/Header";
import ScrollToTop from "components/general/scroll-to-top";
import GlobalBackDrop from "components/mui-common/GlobalBackDrop";
import GlobalSnackBar from "components/mui-common/GlobalSnackBar";
import { useEffect } from "react";
import { BrowserRouter, useLocation, useRoutes } from "react-router-dom";
import { Fragment } from "react/jsx-runtime";
import RoutesData from "routes";
import "styles/App.css";
import "styles/fonts/fonts.css";

// axios.defaults.baseURL =
//   "https://us-central1-haystackers-84f94.cloudfunctions.net/api/v1";

const headerFooterHiddenRoutes = [
  "/signup",
  "/signin",
  "/forgot-password",
  "/reset-password",
];

const App = () => {
  const location = useLocation();
  const theme = useTheme();
  const isMobileView = useMediaQuery(theme.breakpoints.down("md"));
  const showFooterHeader =
    isMobileView || !headerFooterHiddenRoutes?.includes(location?.pathname);

  function Routes() {
    return useRoutes(RoutesData);
  }
  return (
    <Fragment>
      <div id="auto-focus" />
      <ScrollToTop />
      <AuthContainer />
      <GlobalSnackBar />
      <GlobalBackDrop />
      <Header isMobileView={isMobileView} showHeader={showFooterHeader}/>
      <Routes />
      <Footer headerFooterHiddenRoutes={headerFooterHiddenRoutes} />
    </Fragment>
  );
};

export default App;
